import { Transaction } from 'src/app/shared/models/transaction.model';
import { User } from 'src/app/shared/models/user.model';

export class Transfer {
  destinationTransaction!: Transaction;
  sourceTransaction!: Transaction;
  user!: User;
  createdAt: string;

  constructor(input: any = {}) {
    this.destinationTransaction = new Transaction(input.destination_transaction);
    this.sourceTransaction = new Transaction(input.source_transaction);
    this.user = new User(input.user);
    this.createdAt = input.created_at;
  }
}
